import { RoutesConfig } from "@/shared/lib/model/routes";
import type { AuthClientContextType } from "@shared/lib/authClient";
import type { NextRouter } from "next/router";
import type { SubmitHandler, UseFormReturn } from "react-hook-form";
import type { AuthFormFeaturesModel } from "../model";

export const registerSubmitSignInForm = (
	formApi: UseFormReturn<AuthFormFeaturesModel.SignInFields>,
	router: NextRouter,
	authClient: AuthClientContextType
): SubmitHandler<AuthFormFeaturesModel.SignInFields> => {
	const submitSignInForm: SubmitHandler<AuthFormFeaturesModel.SignInFields> = async (props) => {
		const { data, error } = await authClient.signIn.email({
			email: props.email,
			password: props.password
		});
		if (error !== null) {
			const message = error.message || "Unknown error happend, please try again";
			formApi.setError("root.server", {
				message: message,
				type: "default"
			});
			return;
		}
		router.push(RoutesConfig.chat.path);
	};
	return submitSignInForm;
};

export const registerSubmitSignUpForm = (
	formApi: UseFormReturn<AuthFormFeaturesModel.SignUpFields>,
	router: NextRouter,
	authClient: AuthClientContextType
): SubmitHandler<AuthFormFeaturesModel.SignUpFields> => {
	const submitSignUpForm: SubmitHandler<AuthFormFeaturesModel.SignUpFields> = async (props) => {
		const { error } = await authClient.signUp.email({
			email: props.email,
			password: props.password,
			name: "test"
		});
		if (error !== null) {
			const message = error.message || "Unknown error happend, please try again";
			formApi.setError("root.server", {
				message: message,
				type: "default"
			});
			return;
		}
		await router.push(RoutesConfig.onboarding.path);
	};
	return submitSignUpForm;
};

export const extractFirstErrorFromForm = (
	formApi:
		| UseFormReturn<AuthFormFeaturesModel.SignInFields>
		| UseFormReturn<AuthFormFeaturesModel.SignUpFields>
) => {
	const state = formApi.formState;
	if (state.errors.root) {
		if ("message" in state.errors.root) {
			return state.errors.root;
		}
		for (const error of Object.values(state.errors.root)) {
			if (error) {
				return error as Partial<{
					type: string | number;
					message: string;
				}>;
			}
		}
	}
	for (const error of Object.values(state.errors)) {
		if (error) {
			return error;
		}
	}
	return null;
};
